import React, { Fragment, Suspense } from 'react';
import { Fragment as RouteComp } from 'redux-little-router';

import TitleComp from '../components/title';
import { doesAnyRouteMatchCurrent, routeNameMatchCurrent } from './utils';
import { ErrorPage } from '../components/error-page';
import { Spinner } from '../components/ui-helpers';
import { appRouteMap } from './route-configs';
import { titles } from './constants';

export const Routes = () => (
  <RouteComp forRoute="/">
    <Fragment>
      {appRouteMap.map(({ layout: Layout, routes }) => (
        <RouteComp
          key={routes[0][0]}
          withConditions={doesAnyRouteMatchCurrent(routes)}
        >
          <Layout>
            {routes.map(([routeName, Component, exact]) =>
              exact ? (
                <Suspense
                  key={routeName}
                  fallback={<Spinner />}
                >
                  <RouteComp
                    key={routeName}
                    withConditions={routeNameMatchCurrent(routeName)}
                  >
                    <Fragment>
                      <TitleComp title={titles[routeName]} />
                      <Component />
                    </Fragment>
                  </RouteComp>
                </Suspense>
              ) : (
                <Suspense
                  key={routeName}
                  fallback={<Spinner />}
                >
                  <RouteComp key={routeName} forRoute={routeName}>
                    <Fragment>
                      <TitleComp title={titles[routeName]} />
                      <Component />
                    </Fragment>
                  </RouteComp>
                </Suspense>
              ))}
          </Layout>
        </RouteComp>
      ))}
      <RouteComp forNoMatch>
        <ErrorPage
          code={404}
          title="Not Found"
          description="We can't find the page you're looking for. Press Home to return to the Overview page."
        />
      </RouteComp>
    </Fragment>
  </RouteComp>
);



// WEBPACK FOOTER //
// ./src/routes/routes.js